import { TranslocoPipe } from '@jsverse/transloco';
import { Component } from '@angular/core';

@Component({
  selector: 'lib-design-system',
  imports: [TranslocoPipe, ],
  template: `
    <p>
      {{ 'designSystem.ui.designSystemWorks' | transloco }}
    </p>
  `,
  styles: ``
})
export class DesignSystem {

}
